import { Stack } from "@mui/material";
import { Dispatch, SetStateAction } from "react";
import { ExpandToggleButton, FilterToggleButton } from "../views";
import { CustomImpliedVolatilityToggleButton } from "../views/CustomImpliedVolatilityToggleButton";
import {
    PositionImpliedVolatilitySelector
} from "./position-implied-volatility-selector/PositionImpliedVolatilitySelector";
import {
    PositionImpliedVolatilityChangingParameters
} from "./position-implied-volatility-selector/PositionImpliedVolatilityChangingParameters";
import {CustomPriceSelector} from "./CustomPriceSelector";

type PositionsToolsPanelProps = {
    hideClosedOrExpiredPositions: boolean;
    setHideClosedOrExpiredPositions: React.Dispatch<React.SetStateAction<boolean>>;
    isExpanded: boolean;
    setIsExpanded: Dispatch<SetStateAction<boolean>>;
    positionImpliedVolatilityChangingParameters: PositionImpliedVolatilityChangingParameters;
};

export function PositionsToolsPanel({
    hideClosedOrExpiredPositions,
    setHideClosedOrExpiredPositions,
    isExpanded,
    setIsExpanded,
    positionImpliedVolatilityChangingParameters,
}: PositionsToolsPanelProps){
    return(
        <Stack
            direction="row"
            spacing={1}
        >
            <FilterToggleButton
                isActivated={hideClosedOrExpiredPositions}
                setIsActivated={setHideClosedOrExpiredPositions}
                tooltipTextWhenActivated="Show closed positions"
                tooltipTextWhenDeactivated="Hide closed positions"
            />
            <ExpandToggleButton
                isActivated={isExpanded}
                setIsActivated={setIsExpanded}
                tooltipTextWhenActivated="Restore widget"
                tooltipTextWhenDeactivated="Maximise widget"
            />
            <CustomImpliedVolatilityToggleButton />
            <PositionImpliedVolatilitySelector parameters={positionImpliedVolatilityChangingParameters} />
            <CustomPriceSelector />
        </Stack>
    )
}